export default __webpack_public_path__ + "static/media/BananaHeadphones.a0e5b965.jpg";